module.exports = __webpack_public_path__ + "static/media/bg-logo.e32d06f8.png";